//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { catchError, from, Observable, of, switchMap, throwError } from 'rxjs';
import { ConfigSystemParams, eSimApiPaths } from 'src/app/core/consts';
import { ConfigSystemService } from '../system/config-system/config-system-service';
import { ExceptionsService } from './exceptions-service';
import { HttpClientService } from './http-client-service';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })

export class BrowserInfoService {

  get captureLocation() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.NominatimLocationCapture, false); }
  get _getBrowserInfo() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SupportGetBrowserInfo,    false); }

  public hasExecuted: boolean=false;
  
  constructor(
    private configSystemService: ConfigSystemService,
    private exceptionsService  : ExceptionsService,
    private httpClientService  : HttpClientService
  ) {

  }

  private async getBrowserInfo(userLoggedIn: boolean) {
    try {
      const info: any={
        userAgent: navigator.userAgent,
        language : navigator.language,
        timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone
      };
      
      if ((!userLoggedIn || this.captureLocation) &&
           "geolocation" in navigator) {
        try {
          const position=await new Promise<GeolocationPosition>((resolve, reject) =>
                                                                navigator.geolocation.getCurrentPosition(resolve, reject)
                                                               );
          info.location={
            latitude : position.coords.latitude,
            longitude: position.coords.longitude
          };
        } catch {
          //CRN_20250919 - User denied browser location
          info.location=null;
        }
      }
      
      return info;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public _sendBrowserInfo(userLoggedIn: boolean): Observable<any> {
    try {
      return from(this.getBrowserInfo(userLoggedIn))
             .pipe(
               switchMap(browserInfo => this.httpClientService.post(environment.eSimApi +
                                                                    eSimApiPaths.Audit + "/" +
                                                                    (
                                                                      userLoggedIn ?
                                                                      eSimApiPaths.AuditLogBrowserInfo :
                                                                      eSimApiPaths.AuditLogBrowserInfoAnonymous
                                                                    ),
                                                                    browserInfo
                                                                   )
                        ),
               catchError(error => { 
                                   this.exceptionsService.handleException(new Error(error));
                                   return of(null);
                         })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of(null);
    }
  }
  
  public sendBrowserInfo(userLoggedIn: boolean) {
    try {
      if (this._getBrowserInfo && !this.hasExecuted) {
        this._sendBrowserInfo(userLoggedIn)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.hasExecuted=true;
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
